/**
 * Cookie 工具：与后端鉴权对齐，读写 token（游客与登录两种场景均写入 cookie）
 * 后端 LoginUserService 使用 cookie 名 "token" 鉴权
 * token 需带 jpp_ 前缀才视为有效
 */

const COOKIE_TOKEN = 'token';
const TOKEN_PREFIX = 'jpp_';
/** token 前缀为 jpp_guest 时视为游客模式 */
export const TOKEN_PREFIX_GUEST = 'jpp_guest';
/** token 前缀为 jpp_manager 时视为管理员，admin 页面免登录 */
export const TOKEN_PREFIX_MANAGER = 'jpp_manager';
const COOKIE_MAX_AGE_DAYS = 365;
const COOKIE_PATH = '/';

function setCookie(name: string, value: string): void {
  if (typeof document === 'undefined') return;
  const maxAge = COOKIE_MAX_AGE_DAYS * 24 * 60 * 60;
  document.cookie = `${name}=${encodeURIComponent(value)}; path=${COOKIE_PATH}; max-age=${maxAge}; SameSite=Lax`;
}

function getCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

function deleteCookie(name: string): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${name}=; path=${COOKIE_PATH}; max-age=0`;
}

/** 设置鉴权 cookie（仅 token）；后端返回的 token 已带 jpp_ 前缀，原样写入 */
export function setAuthCookies(token: string): void {
  if (token) setCookie(COOKIE_TOKEN, token);
}

/** 读取当前 token */
export function getAuthToken(): string | null {
  return getCookie(COOKIE_TOKEN);
}

/** 登出或清除身份时删除 token */
export function clearAuthCookies(): void {
  deleteCookie(COOKIE_TOKEN);
}

/** 是否已有有效 token（带 jpp_ 前缀才视为有效，用于判断是否需要游客初始化） */
export function hasAuthToken(): boolean {
  const token = getAuthToken();
  return !!(token && token.startsWith(TOKEN_PREFIX));
}

/** 是否为游客模式（cookie 中 token 前缀为 jpp_guest） */
export function isGuestMode(): boolean {
  const token = getAuthToken();
  return !!(token && token.startsWith(TOKEN_PREFIX_GUEST));
}

/** 是否为管理员模式（cookie 中 token 前缀为 jpp_manager，admin 页面免登录） */
export function isManagerMode(): boolean {
  const token = getAuthToken();
  return !!(token && token.startsWith(TOKEN_PREFIX_MANAGER));
}
